// We can't use the theme in this stylesheet due to some SSG pre-render race condition
import { grey } from '@mui/material/colors';

const blogPostStyle = () => ({
  homeCta: {
    alignSelf: 'flex-end',

    '.blogTitle': {
      // display: '-webkit-box',
      // overflow: 'hidden',
      // WebkitBoxOrient: 'vertical',
      // WebkitLineClamp: 3,
      lineHeight: '2.5rem'
    },

    '.blogSummary': {
      display: '-webkit-box',
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2
    }
  },

  breadcrumbs: {
    flexGrow: 0,
    width: '100%',
    paddingBottom: 10
  },

  byline: {
    fontSize: '0.9rem',
    marginBlockEnd: 0
  },

  sidebar: {
    alignContent: 'start',
    alignItems: 'flex-start',
    gap: 15
  },

  sidebarBox: {
    width: '100%',
    overflow: 'hidden',
    padding: 10,
    position: 'relative',

    // Templates
    '&.fullBleed': {
      padding: 0
    }
  },

  blogHomeCard: {
    '.blogTitle': {
      display: '-webkit-box',
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      height: 65
    },
    '.blogSummary': {
      display: '-webkit-box',
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 3,
      height: 64
    },
    button: {
      paddingLeft: 0
    }
  },

  blogContent: {
    '.imageCaption': {
      textAlign: 'center',
      fontSize: '0.9rem',
      color: grey[600]
    },

    // Ads
    '.inlinePostIntro': {
      padding: 15,
      borderRadius: 10,
      overflow: 'hidden',
      marginBottom: 16
    }
  },

  blogTitle: {
    lineHeight: '2.4rem'
  },

  socialShare: {
    a: {
      '&:first-child': {
        marginLeft: 0
      }
    }
  }
});

export default blogPostStyle;
